"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRewardToString = void 0;
/**
 * convertRewardToString function To append a currency symbol to an amount
 * - If displaySymbol is $ it will display before the amount.
 * - If displaySymbol is not $ display unit will display after the amount.
 *
 * @param amount - Amount variables
 * @returns {string} - The formatted string, or original/empty string based on conditions.
 */
const convertRewardToString = (rw) => {
    if (!rw) {
        return "";
    }
    if (rw.negative) {
        return rw.displaySymbol === "$"
            ? `-${rw.displaySymbol}${rw.displayValue}`
            : `-${rw.displayValue} ${rw.displayUnit}`;
    }
    return rw.displaySymbol === "$"
        ? `${rw.displaySymbol}${rw.displayValue}`
        : `${rw.displayValue} ${rw.displayUnit}`;
};
exports.convertRewardToString = convertRewardToString;
